import { makeStyles } from '@material-ui/core';
import { CSSProperties } from 'react';

export const useStyles = makeStyles(() => ({
  active: {
    transform: `translateX(0)`,
  },
}));

export const getScrollbarsStyle = (): CSSProperties => ({
  flex: 1,
});
